<template>
    <div>
        <h5 class="fusedship-title title mb-5">
            Live Rates
        </h5>
        <router-view></router-view>
    </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
    computed: {
        ...mapGetters(['isAdmin', 'userIntegrationIds']),
    },

    mounted () {
        const {
            filter
        } = this.$route.query

        if(!this.isAdmin) {
            // validate user if has access to live rates
            const userIntegrationIds = this.userIntegrationIds
            if (!userIntegrationIds || userIntegrationIds.length === 0) {
                this.$router.replace('/');
            }

            if(filter && userIntegrationIds.indexOf(parseInt(filter)) === -1) {
                this.$router.replace('/');
            }
        }
    }
}
</script>